/**
 * AdminPaymentsTab — Payments tab content for the Admin Dashboard.
 * Hosts the writer payout queue + the placeholder revenue/subscriptions
 * cards. Extracted from AdminDashboard.jsx (Jun 4 2026).
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import AdminPayoutQueue from './AdminPayoutQueue';

const AdminPaymentsTab = () => (
  <>
    <div className="mb-6">
      <AdminPayoutQueue />
    </div>
    <Card className="bg-slate-800/50 border-slate-700">
      <CardHeader>
        <CardTitle className="text-white">Payment Management</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <Card className="bg-slate-700/30 border-slate-600">
            <CardContent className="p-4">
              <p className="text-sm text-gray-400 mb-1">Total Revenue</p>
              <p className="text-2xl font-bold text-green-400">$0.00</p>
            </CardContent>
          </Card>
          <Card className="bg-slate-700/30 border-slate-600">
            <CardContent className="p-4">
              <p className="text-sm text-gray-400 mb-1">Active Subscriptions</p>
              <p className="text-2xl font-bold text-blue-400">0</p>
            </CardContent>
          </Card>
          <Card className="bg-slate-700/30 border-slate-600">
            <CardContent className="p-4">
              <p className="text-sm text-gray-400 mb-1">Pending Payouts</p>
              <p className="text-2xl font-bold text-yellow-400">$0.00</p>
            </CardContent>
          </Card>
        </div>
        <p className="text-gray-400 text-center py-4">No payment transactions yet</p>
        <div className="mt-6 p-4 bg-indigo-900/20 border border-indigo-700/30 rounded-lg">
          <p className="text-sm text-indigo-300 text-center">
            💡 Payment integration coming soon (Stripe/PayPal)
          </p>
        </div>
      </CardContent>
    </Card>
  </>
);

export default AdminPaymentsTab;
